<template>
  <notification-list
    ref="list"
    :show-profile="showProfile"
    :show-trigger="true"
    :campaign-id="this.$route.query.id"
  />
</template>

<script>
import NotificationList from '@/modules/notifications-log/components/NotificationList'
import { ActionStatusEnum } from '@/common/enum/ActionStatusEnum'
import { campaignTriggerTypes } from '../../campaign-manage/enum/CampaignTriggerTypesEnum'

export default {
  name: 'CampaignExecutionsPage',

  props: {
    campaign: {
      type: Object
    }
  },

  components: {
    NotificationList
  },

  data() {
    return {
      refreshInterval: null
    }
  },

  computed: {
    showProfile() {
      return (
        this.campaign &&
        [
          campaignTriggerTypes.TRIGGER_LOCATION,
          campaignTriggerTypes.TRIGGER_EVENT,
          campaignTriggerTypes.TRIGGER_ACCUMULATION
        ].includes(this.campaign.trigger)
      )
    }
  },

  destroyed() {
    clearInterval(this.refreshInterval)
  },

  created() {
    this.refreshInterval = setInterval(() => {
      this.refreshIfProcessing()
    }, 2500)
  },

  methods: {
    refreshIfProcessing() {
      let data = this.$refs.list.$refs.list.data

      let processing = data.filter(item => {
        return (
          item.status !== ActionStatusEnum.SENT &&
          item.status !== ActionStatusEnum.CANCELLED
        )
      })

      if (!data.length || processing.length) {
        this.$refs.list.refresh(true)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaigns/pages/CampaignExecutionsPage.vue